const ExamCategoryType = {
	None: 0,
	YKS: 1,
	LGS: 2,
	KPSS:3
};

export default ExamCategoryType;